const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  roles: (state) => state.user.roles,
  abilities: (state) => state.user.abilities,
  permission_routes: (state) => state.permission.routes,
  company_id: (state) => state.user.company_id,
  company: (state) => state.user.company,
};
export default getters;
